import React, { Component } from 'react'
import {Switch, Route, Redirect} from "react-router-dom";
import List from './List'
import Create from "./Create";
import Details from "./Details";

class BackofficeWaitingList extends Component {
    render () {
        return (
            <Switch>
                <Route path="/backoffice/waiting-lists/list" component={List} />
                <Route path="/backoffice/waiting-lists/create" component={Create} />
                <Route path="/backoffice/waiting-lists/:id" component={Details} />
                <Redirect to="/backoffice/waiting-lists/list" />
            </Switch>
        )
    }
}

export default BackofficeWaitingList



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/BackofficeWaitingList.js